module.exports = __webpack_public_path__ + "img/Feature.e11ae91e.jpg";